import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { NavigationHeaderComponent } from '@shared/src/lib/components/navigation-header/navigation-header.component';
import { SideNavigationComponent } from '@shared/src/lib/components/side-navigation/side-navigation.component';
import { LocalStorageService } from '@shared/src/services/local-storage.service';
import {
  isValidUserRole,
  NAVIGATION_ACCESS_MAP,
  NavigationAccess,
  SIDE_NAVIGATION_ITEMS,
} from './private-layout.config';

@Component({
  selector: 'app-private-layout',
  standalone: true,
  imports: [RouterOutlet, NavigationHeaderComponent, SideNavigationComponent],
  templateUrl: './private-layout.component.html',
  styleUrl: './private-layout.component.css',
})
export class PrivateLayoutComponent {
  sideNavigationItems = [...SIDE_NAVIGATION_ITEMS];
  constructor(private readonly localStorageService: LocalStorageService) {
    this.initializeNavigation();
  }

  private initializeNavigation(): void {
    const userInfo = this.localStorageService.getData('user');
    if (!userInfo) {
      return;
    }

    const userObj = JSON.parse(userInfo);
    const { roleName } = userObj;
    if (isValidUserRole(roleName)) {
      const roleAccess = NAVIGATION_ACCESS_MAP[roleName];
      this.sideNavigationItems.forEach((item) => {
        const path = item.path as keyof NavigationAccess;
        item.isVisible = roleAccess[path];
      });
    }
  }
}
